module.exports = __webpack_public_path__ + "64de04b7b8ae74fba50b955f6b724941.jpg";